import React from 'react';

import './AuHintText.scss';

interface Props {
  text: string | React.ReactNode;
  className?: string;
  dark?: boolean;
  alt?: boolean;
  htmlFor: string;
  style?: React.CSSProperties;
}

/**
 * DEFAULT
 * The Hint text component
 */
const AuHintText: React.FC<Props> = ({ text, dark, alt, className = '', ...attributeOptions }) => (
  <span className={
    `au-hint-text ${className}` +
    `${alt ? ' au-hint-text--alt' : ''}` +
    `${dark ? ' au-hint-text--dark' : ''}`
  }
  {...attributeOptions}>
    {text}
  </span>
);

export default AuHintText;